import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: {
    loading: false,
    error: null,
  },
};

export const userSlice = createSlice({
  name: "userInfo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase("logout", () => ({ ...initialState, loggedIn: false }));
  },
});

// export const {} = userSlice.actions;

export const selectUser = (state) => state.userInfo.user;

export default userSlice.reducer;
